import { render } from "./ChiTietDeTai.vue?vue&type=template&id=ddcb2c58&scoped=true&ts=true"
import script from "./ChiTietDeTai.vue?vue&type=script&lang=ts"
export * from "./ChiTietDeTai.vue?vue&type=script&lang=ts"

import "./ChiTietDeTai.vue?vue&type=style&index=0&id=ddcb2c58&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcb2c58"]])

export default __exports__